import React, { useEffect, useState } from "react";
import { Helmet } from "react-helmet";
import { Contact, Header, Footer } from "../../components/layouts/index";
import { Loader } from "src/components/shared";
import { client } from "src/utils/api";
import Banner from "src/components/Banner/Banner";

export type LayoutProps = {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  saleClassName?: string;
  headerStyle?: React.CSSProperties;
  isHome?: boolean;
  hamburgerStyle?: React.CSSProperties;
  isFooterComponent?: boolean;
  loading?: boolean;
  seoData?: any;
};

const Layout = ({
  children,
  style,
  isFooterComponent = false,
  loading,
  seoData,
  saleClassName,
  headerStyle,
  isHome,
  hamburgerStyle,
}: LayoutProps) => {
  const gqlClient = client;
  const {
    pageTitle,
    pageDescription,
    canonicalUrl,
    noindex,
    nofollow,
    shareImagesCollection,
  } = seoData || {};

  const shareImageUrl =
    shareImagesCollection && shareImagesCollection.items.length > 0
      ? shareImagesCollection.items[0].url
      : null;

  const [layoutData, setLayoutData] = useState<any>(null);
  const [menuItems, setMenuItems] = useState<any>();
  const [subMenuItems, setSubMenuItems] = useState<any>();
  // Fetch layout data

  useEffect(() => {
    const fetchLayoutData = async () => {
      try {
        const [layoutResponse, menuIdResponse, subMenuItemsResponse] =
          await Promise.all([
            gqlClient.GetLayoutComponents({
              componentsLimit: 10,
              navigationLinksLimit: 5,
              callToActionLimit: 5,
              linksLimit: 5,
              socialMediaLinksLimit: 5,
            }),
            gqlClient.GetMenuId(),
            gqlClient.GetSubMenuItems(),
          ]);

        const layoutItems =
          layoutResponse?.layoutComponentsCollection?.items[0]
            ?.componentsCollection?.items || [];
        setLayoutData(layoutItems);

        const menuId = menuIdResponse?.menuCollection?.items[0]?.sys?.id ?? "";
        if (menuId) {
          const menuResponse = await gqlClient.GetMenu({ menuId });
          setMenuItems(menuResponse?.menu?.menuItemsCollection?.items || []);
        }

        const subMenuItems =
          subMenuItemsResponse?.menuItemCollection?.items || [];
        setSubMenuItems(subMenuItems);
      } catch (error) {
        console.error("Error fetching homepage data:", error);
      }
    };

    fetchLayoutData();
  }, []);

  return (
    <>
      {loading ? (
        // <Loader />
        <></>
      ) : (
        <>
          <Helmet>
            <title>{pageTitle ?? "Gradial Summit 2025"}</title>
            <meta
              name="description"
              content={pageDescription ?? "Default description"}
            />

            {canonicalUrl && <link rel="canonical" href={canonicalUrl} />}

            <meta
              name="robots"
              content={`${noindex ? "noindex" : "index"}, ${nofollow ? "nofollow" : "follow"}`}
            />

            {shareImageUrl && (
              <meta property="og:image" content={shareImageUrl} />
            )}
            <meta property="og:title" content={pageTitle ?? "Default Title"} />
            <meta
              property="og:description"
              content={pageDescription ?? "Default Description"}
            />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={pageTitle ?? "Default Title"} />
            <meta
              name="twitter:description"
              content={pageDescription ?? "Default Description"}
            />
            {shareImageUrl && (
              <meta name="twitter:image" content={shareImageUrl} />
            )}
          </Helmet>
          
         {layoutData?.length > 0 && <Banner bannerCollections={layoutData[3] ?? []} /> } 

          {layoutData?.length > 0 && (
            <Header
              logo={layoutData[0]?.logoCollection?.items}
              callToAction={layoutData[0]?.callToActionCollection?.items}
              style={style}
              saleClassName={saleClassName}
              hamburgerStyle={hamburgerStyle}
              isHome={isHome}
              menuItems={menuItems}
              headerStyle={headerStyle}
              subMenuItems={subMenuItems}
            ></Header>
          )}

          <main>{children}</main>

       

          {layoutData?.length > 2 && (
            <Footer
              content={layoutData[2]}
              logoUrl={layoutData[2].logo.logoImage.url}
              contactData={
                layoutData[1]
                  ? {
                      title: layoutData[1].title,
                      buttonData: layoutData[1].buttonLink,
                      bgImage: layoutData[1].image,
                    }
                  : undefined
              }
            />
          )}
        </>
      )}
    </>
  );
};

export default Layout;
